import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Inicio', id: 'inicio' },
    { label: 'Productos', id: 'productos' },
    { label: 'Cuidado de la Piel', id: 'cuidado' },
    { label: 'Calidad', id: 'aprobacion' },
    { label: 'Por Mayor', id: 'distribucion' },
    { label: 'Contacto', id: 'contacto' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/7111f617ff52b664a5493fd29ab7be63.jpeg"
              alt="Logo"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-7">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm font-light transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contacto')}
            className="hidden lg:block px-6 py-2.5 bg-[#D4AF37] text-gray-900 text-sm font-medium rounded-full hover:bg-[#C19B2B] transition-colors whitespace-nowrap cursor-pointer"
          >
            Contactar
          </button>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <div className={`w-6 h-6 flex items-center justify-center ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </div>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-sm text-gray-700 hover:text-gray-900 py-2 cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contacto')}
              className="w-full px-6 py-2.5 bg-[#D4AF37] text-gray-900 text-sm font-medium rounded-full hover:bg-[#C19B2B] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contactar
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
